/// <amd-module name="VC/Common/Utils/Telemetry" />
import { VersionControlArea } from "VC/Common/Contracts/Constants";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";

interface TelemetryTimer {
    publishTime(action: string, extraProperties?: any): void;
}

/**
 * Saves current time and returns an object with a method to publish elapsed time later.
 */
export function startTelemetryTimer(pageContext: IVssPageContext, featureName: string): TelemetryTimer {
    const startTime = Date.now();

    return {
        publishTime: function(action: string, extraProperties: any) {
            const telemetryService = pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
            telemetryService.publishEvent(
                VersionControlArea,
                featureName,
                {
                    action,
                    elapsedMs: Date.now() - startTime,
                    ...extraProperties,
                });
        },
    };
}
